import { type TLocaleContextValue, toLanguageCode } from '@frontends/util-i18n';
import { getEntityConfig } from '@/hooks/useEntityConfig';
import { type ClientSummary } from '@/types/Auth';

/**
 * The external client portal is keyed by primary subtag in its own URLs
 * (`my.example.com/en/security`), so the enabled BCP 47 language is narrowed only at
 * the moment it goes into that path.
 */
export const replaceLanguageInUrl = (url: string, localeContext: TLocaleContextValue): string => {
  const config = getEntityConfig();
  const enabled = config.VITE_CLIENT_PORTAL_SUPPORTED_LOCALES.includes(localeContext.locale.language);
  const languageForClientPortal = enabled ? toLanguageCode(localeContext.locale.language) : 'en';

  return url.replace('/en/', `/${languageForClientPortal}/`);
};

type ProfileNames = Pick<ClientSummary, 'first_name' | 'last_name' | 'name'>;

export const getInitials = (details: ProfileNames): string | undefined => {
  const hasPersonalName = details.first_name.trim() !== '' || details.last_name.trim() !== '';
  const nameParts = hasPersonalName
    ? [details.first_name, details.last_name]
    : details.name.trim().split(/\s+/).slice(0, 2);
  const initials = nameParts
    .map((part) => part.trim().charAt(0))
    .join('')
    .toUpperCase();

  return initials === '' ? undefined : initials;
};
